import { useIntl } from 'react-intl'
import { auditHeaderMessages } from './messages'
import {
  AuditCheckForNewLogsButton,
  AuditHeaderContainer,
  AuditHeaderTitle,
} from './styles'

interface AuditHeaderProps {
  handleRenewLogs: () => void
}

function AuditHeader({ handleRenewLogs }: AuditHeaderProps) {
  const { formatMessage } = useIntl()
  return (
    <AuditHeaderContainer>
      <AuditHeaderTitle>
        {formatMessage(auditHeaderMessages.audit)}
      </AuditHeaderTitle>
      <AuditCheckForNewLogsButton variant="secondary" onClick={handleRenewLogs}>
        {formatMessage(auditHeaderMessages.refresh)}
      </AuditCheckForNewLogsButton>
    </AuditHeaderContainer>
  )
}

export default AuditHeader
